import { Link, useNavigate, useParams } from "react-router-dom";
import { Radio } from "lucide-react";
import { useFetch } from "@/lib/api";
import { usePageMeta, PageHeader, EmptyState, Loader, ErrorState, StatusBadge } from "@/components/common";
import { LiveStandings } from "@/components/LiveStandings";

export default function Standings() {
  const { slug } = useParams();
  const navigate = useNavigate();
  usePageMeta("Classifiche live", "Classifiche aggiornate in tempo reale degli eventi NEXUM LEGACY.");
  const live = useFetch("/live");
  const recent = useFetch("/events", { status: "concluso", limit: 6 });
  const events = [...(live.data || []), ...(recent.data?.items || [])];
  const current = slug || events[0]?.slug;
  return (
    <div data-testid="standings-page">
      <PageHeader eyebrow="Realtime" title="Classifiche live" subtitle="Le posizioni si aggiornano automaticamente a ogni risultato registrato dallo staff." />
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-10">
        {live.error ? <ErrorState message={live.error} onRetry={live.reload} /> : live.loading || recent.loading ? <Loader /> : !events.length ? (
          <EmptyState icon={Radio} title="Nessuna classifica disponibile" text="Le classifiche appariranno quando un evento sarà in corso o concluso." />
        ) : (
          <>
            <div className="flex flex-wrap gap-2 mb-8" role="tablist">
              {events.map((e) => (
                <button key={e.id} data-testid={`standings-event-${e.slug}`} onClick={() => navigate(`/classifiche/${e.slug}`)} className={`flex items-center gap-2 px-4 py-2 rounded-md border text-xs uppercase tracking-wider font-display transition-colors duration-200 ${current === e.slug ? "border-[#962FFF]/60 bg-[#962FFF]/10 text-[#F5F5F7]" : "border-[#C6C6CE]/15 text-[#C6C6CE]/70 hover:text-[#F5F5F7]"}`}>
                  {e.status === "in_corso" && <span className="w-1.5 h-1.5 rounded-full bg-[#962FFF] live-dot" />}{e.title}
                </button>
              ))}
            </div>
            {current && (
              <div key={current}>
                <div className="flex items-center gap-3 mb-6">
                  <Link to={`/eventi/${current}`} className="text-sm text-[#C6C6CE]/70 hover:text-[#F5F5F7]">Dettaglio evento →</Link>
                  {events.find((e) => e.slug === current) && <StatusBadge status={events.find((e) => e.slug === current).status} />}
                </div>
                <LiveStandings slug={current} />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
